import { HttpInterceptorFn } from '@angular/common/http';

/**
 * When Node SSR talks to Rails on loopback (`http://127.0.0.1:3001`), Rails
 * HostAuthorization still expects the public API host. Set SSR_API_HOST in the
 * process environment (e.g. staging.livoapp.livornos.com).
 */
export const ssrApiHostInterceptor: HttpInterceptorFn = (req, next) => {
  const host = (typeof process !== 'undefined' ? process.env['SSR_API_HOST'] : '')?.trim();
  if (!host) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { Host: host } }));
};
